var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1945 3.64951C7.91634 1.291 11.3985 -0.00501044 15 1.45577e-05C23.2845 1.45577e-05 30 6.71551 30 15C30 18.204 28.995 21.174 27.285 23.61L22.5 15H27C27.0001 12.6474 26.3088 10.3467 25.012 8.3839C23.7151 6.42108 21.8698 4.88275 19.7058 3.96019C17.5416 3.03765 15.154 2.77156 12.84 3.19504C10.5258 3.61851 8.38717 4.71286 6.69 6.34201L5.1945 3.64951ZM24.8055 26.3505C22.0836 28.7089 18.6015 30.0051 15 30C6.7155 30 0 23.2845 0 15C0 11.796 1.005 8.82601 2.715 6.39001L7.5 15H3C2.9998 17.3526 3.69112 19.6533 4.98801 21.6162C6.28488 23.5789 8.1301 25.1173 10.2942 26.0398C12.4584 26.9623 14.8459 27.2284 17.16 26.805C19.4742 26.3815 21.6127 25.2871 23.31 23.658L24.8055 26.3505Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V16.3354L21.6683 19.6695",
    stroke: "#B08C3D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.008c5ed5015a14f8315914a14ca6cadc.svg";
export { ForwardRef as ReactComponent };